<main class="flex flex-col h-screen bg-background text-foreground p-2">
    <au-viewport class="flex flex-col flex-grow overflow-hidden space-y-2"></au-viewport>

    <footer class="flex flex-col sm:flex-row items-center justify-between text-center text-sm">
        <div>Data and images from The <a href="https://talesofcrestoria.fandom.com/wiki/Tales_of_Crestoria_Wiki">Tales of Crestoria Fan Wiki</a>.</div>
        <a href="https://github.com/CuddleBunny/toc-sub-grid-calc/issues">Bugs &amp; Feedback</a>
    </footer>
</main>